export const fontWeights = {
  light: 300,
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  heavy: 900,
} as const;

export type FontWeight = (typeof fontWeights)[keyof typeof fontWeights];
